import { render } from "./IconLink.vue?vue&type=template&id=6de22805"
import script from "./IconLink.vue?vue&type=script&lang=ts"
export * from "./IconLink.vue?vue&type=script&lang=ts"
script.render = render

export default script